import React from "react"
import {
  OrderShippingWalleyDeliveryModule,
  WalleyDeliveryModuleShipping
} from "lib/types/generated/graphql-types"
import { ReactComponent as WalleyLogo } from "images/providers/walley-logo.svg"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import { Container, Row, Title } from "./Styled"

type Props = {
  shippingWalley: OrderShippingWalleyDeliveryModule | undefined
}

const WalleyDeliveryModuleDetails = ({ shippingWalley }: Props) => {
  const isWalleyShipping = (
    shipping: typeof shippingWalley
  ): shipping is OrderShippingWalleyDeliveryModule & {
    walleyShipping: WalleyDeliveryModuleShipping
  } => shipping?.__typename === "OrderShippingWalleyDeliveryModule" && "walleyShipping" in shipping

  const walleyData = isWalleyShipping(shippingWalley) ? shippingWalley.walleyShipping : undefined

  if (!walleyData?.shipments?.length) return null

  return (
    <>
      <Title $logoMargin={"0 0.8rem 0"}>
        <WalleyLogo /> details
      </Title>
      {walleyData.shipments.map((shipment, index) => (
        <Container key={index}>
          <Row>
            <ListEntry 
              label={shipment.shippingChoice.name ?? "Shipping Choice"} 
              value={shipment.shippingChoice.id ?? "-"} 
            />
            <ListEntry 
              label={"Booked shipment ID"} 
              value={shipment.bookedShipmentId ?? "-"} 
            />
          </Row>
          <Row>
            <ListEntry 
              label={"External shipment ID"} 
              value={shipment.externalShipmentId ?? "-"} 
            />
            <ListEntry 
              label={"Destination Name"} 
              value={shipment.shippingChoice.destination.name ?? "-"} 
            />
          </Row>
          <Row>
            <ListEntry 
              label={"Destination ID"} 
              value={shipment.shippingChoice.destination.id ?? "-"} 
            />
            <div />
          </Row>
        </Container>
      ))}
    </>
  )
}

export default WalleyDeliveryModuleDetails
